import { PanelEditorDockingPanelContent } from "./content/panelEditorDockingPanelContent";
import { DockingPanel } from "./dockingPanel";

export class PanelDockingPanel {
    private readonly panel: DockingPanel;
    private visible: boolean;

    constructor(container: HTMLElement) {
        this.visible = false;

        const component = (<PanelEditorDockingPanelContent />);

        this.panel = new DockingPanel(container, "dextall-studio-wall-panel-editor", "Panel properties", component, {
            style: {
                width: "360px",
                height: "592px",
                minWidth: "360px",
                minHeight: "592px",
                resize: "both",
                left: "2px",
                top: "2px",
            },
        });
        this.panel.addVisibilityListener((x: boolean) => this.visible = x);
    }

    setVisible(visibility: boolean) {
        if (this.visible === visibility) {
            return;
        }

        this.visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}
